import * as React from 'react';
import { DEFAULT_DESCRIPTION_MESSAGE, UNAUTHORIZED_DESCRIPTION_MESSAGE } from './constants';
import { LogoutButton, HomeButton, ReloadButton } from './MessageActions';
export var getAPIErrorMessage = function (response) {
    var status = response && response.status;
    switch (status) {
        case 401:
            return {
                message: 'Unauthorized Page',
                description: UNAUTHORIZED_DESCRIPTION_MESSAGE,
                helper: 'Status code: 401',
                actions: [React.createElement(LogoutButton, { key: "logout" })]
            };
        case 403:
            return {
                message: 'Forbidden Page',
                description: 'Sorry! You don’t have permission to view this page.',
                helper: 'Status code: 403',
                actions: [React.createElement(HomeButton, { key: "home" })]
            };
        case 500:
            return {
                message: 'Internal Server Error',
                description: DEFAULT_DESCRIPTION_MESSAGE,
                helper: 'Status code: 500',
                actions: [React.createElement(ReloadButton, { key: "reload" }), React.createElement(LogoutButton, { key: "logout" })]
            };
        case 504:
            return {
                message: 'Error: Gateway Timeout',
                description: DEFAULT_DESCRIPTION_MESSAGE,
                helper: 'Status code: 504',
                actions: [React.createElement(ReloadButton, { key: "reload" }), React.createElement(LogoutButton, { key: "logout" })]
            };
        default:
            var details = (response && response.message) || response;
            return {
                message: 'Error',
                description: DEFAULT_DESCRIPTION_MESSAGE,
                helper: !isNaN(status)
                    ? "Status code: " + status
                    : details &&
                        "Details: " + (typeof details === 'string'
                            ? details
                            : details['detail'] ||
                                details['message'] ||
                                JSON.stringify(details)),
                actions: [React.createElement(ReloadButton, { key: "reload" }), React.createElement(LogoutButton, { key: "logout" })]
            };
    }
};
//# sourceMappingURL=getAPIErrorMessage.js.map